import React from 'react';
import { C as CartItemDrawerSkeleton } from './CartItemDrawerSkeleton-pSF-OxYE.js';
import { S as Skeleton } from './Skeleton-RKr5mJai.js';

const ITEMS_COUNT = 1;
const ShoppingCartDrawerSkeleton = () => (React.createElement("div", { className: "shopping-cart-content" },
    React.createElement("div", { className: "shopping-cart-list" },
        React.createElement("div", { className: "body" }, Array(ITEMS_COUNT)
            .fill(0)
            .map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(CartItemDrawerSkeleton, { key: index }))))),
    React.createElement("div", { className: "checkout-container" },
        React.createElement(Skeleton, { width: "100%", height: 50, marginBottom: 0 }))));

export { ShoppingCartDrawerSkeleton as S };
//# sourceMappingURL=ShoppingCartDrawerSkeleton-kCFrECX9.js.map
